import React from 'react';
import { Grid, /* Header, */ Segment, Progress, Icon, Modal } from 'semantic-ui-react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import ReactGA from 'react-ga';

import PJModal from './componentsHelpers/Modal';
import WorkFormB from './components/WorkFormB';
import AddressForm from './components/AddressForm';
import PersonalDetailsForm from './components/PersonalDetailsForm';
import DBAFormTwo from './components/DBAFormTwo';
import EmailForm from './components/EmailForm';
import ConsentForm from './components/ConsentForm';

import { postLead, putLead, getLead, getDBAPDF } from './api/request';
import adapter from './utilities/adapter';
import { queryString } from './utilities/queryString';
import setInjectionStep from './utilities/setInjectionStep';
import regexs from './utilities/regexs';
import messages from './utilities/validationMessages';

import './App.css';
import { buildPDF } from 'utilities/pdf';

class App extends React.Component<any, any> {
  state: any = {
    step: 1,
    backStep: null,
    percent: 16.67,
    motivation: 0,
    leadId: '',
    modalOpen: false,
    modalSize: 'mini',
    modalContent: null,
    uploadedDocs: false,
    sessionMarketingDataSent: false,
    revisitingLead: false,
    timeRunningOut: false,
    highCourtLead: false,
    formData: {
      //...testData
      stp1_stillWorkThere: '',
      stp1_endDate: '',
      stp1_storeDetails: '',
      stp1_hourlyWage: '',

      stp2_postCode: '',
      stp2_houseNumName: '',
      stp2_streetRoad: '',
      stp2_town: '',
      stp2_country: '',

      stp3_firstName: '',
      stp3_title: '',
      stp3_lastName: '',
      stp3_emailAddress: '',
      stp3_telephone: '',
      stp3_dob: '',
      stp3_gender: '',
      stp3_nationalInsurance: '',

      stp4_consentPermission: false,
      stp4_contactPermission: false,

      stp5_dbaAgreed: false,
      stp5_dbaAgreedTS: '',

      email_input: ''
    }
  };

  componentDidMount() {
    const queryString: boolean = regexs.leadUUid.test(window.location.href) || window.location.href.includes('retargeted');

    if (queryString) {
      //open modal wile lead is routed
      this.setState({
        modalOpen: true,
        modalContent: this.modalContent('Please wait, this won\'t take long', 'We are redirecting you...', true)
      });
      this.handleRevisitingLead();
    };

    Object.assign(window, { PJ_Email_Form: () => this.manualStep('EMAIL_FORM') });
  };

  initializeReactGA() {
    ReactGA.initialize('UA-35903174-15', { testMode: true });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  gaEvent = (
    hitType: string,
    eventCategory: string,
    eventAction: string,
    eventLabel: string,
    isValid: boolean
  ): void => {
    if (isValid) {
      console.log(`GA event: hitType - ${hitType}, eventCategory - ${eventCategory}, eventAction - ${eventAction}, eventLabel - ${eventLabel}`);
      ReactGA.ga('send', {
        hitType,
        eventCategory,
        eventAction,
        eventLabel
      });
    }
  }

  handleRevisitingLead = () => {
    if (regexs.leadUUid.test(window.location.href)) {
      // if lead has a lead_id query string in the URL
      const uuid: string | null = queryString('lead_id')
      this.routeRevisitingLead(uuid)
    }
    // if a lead has 'retagrgeted' query string in the url
    else if (window.location.href.includes('retargeted')) {
      this.setState({
        modalOpen: false
      })
      this.manualStep('EMAIL_FORM');
    }
  };

  routeRevisitingLead = (uuid: string | null) => {
    getLead(uuid)()
      .then(response => {
        const { data } = response;
        let { step } = setInjectionStep(data);

        const values = {
          revisitingLead: true
        };

        getDBAPDF()
          .then((buffer) => buildPDF(buffer, values))
          .then((pdfUrl) => {
            this.setState({
              revisitingLead: true,
              leadId: uuid,
              modalOpen: false,
              pdfUrl,
              step
            });
          });
      })
      .catch(error => {
        this.manualStep(0);
        console.log(error);
      });
  };

  handleEndDate = (vals: any) => {
    const date = vals.stp1_endDate
    if (date && date.length) {
      const endDate = moment(date, 'DD/MM/YYYY');
      const sixYrs = moment().subtract(6, 'years');
      const fiveMTwoW = moment().subtract(6, 'months').add(2, 'weeks');
      const fourMThreeW = moment().subtract(5, 'months');

      if (endDate.isAfter(sixYrs, 'day')) {
        if (endDate.isBefore(fiveMTwoW, 'day')) {
          this.setState({ highCourtLead: true });
        } else if (endDate.isAfter(moment(fiveMTwoW).subtract(1, 'day')) && endDate.isSameOrBefore(fourMThreeW)) {
          this.setState({ timeRunningOut: true });
        } else {
          this.setState({ highCourtLead: false, timeRunningOut: false });
        }
      };
    }
  }

  prevStep = () => {
    const { step, percent, motivation } = this.state;
    this.setState({
      step: step - 1,
      percent: percent * ((step - 1) / step),
      motivation: motivation - 1
    });
  };

  nextStep = (props: any) => {
    const { step } = this.state;
    props.submitForm().then(() => {
      if (props.isValid) {
        // check end date to check user is high court or time running out lead
        if (step === 1) this.handleEndDate(props.values);

        this.pushToCMS(props.values);

        if (this.state.step === 4 && this.state.highCourtLead) {
          this.setState({
            step: 'HIGH_COURT_LEAD',
            modalOpen: true,
            modalContent: this.modalContent(`Loading`, 'Please wait', true)
          });
        } else if (this.state.step === 4 && this.state.timeRunningOut) {
          this.setState({
            step: 'TIME_RUNNING_OUT',
            modalOpen: true,
            modalContent: this.modalContent(`Loading`, 'Please wait', true)
          });
        } else if (this.state.step === 4) {
          this.setState({
            step: 5,
            modalOpen: true,
            modalContent: this.modalContent(`Loading`, 'Please wait', true)
          });
        } else if (this.state.step === 5) {
          this.setState({
            step: 6,
            modalOpen: true,
            modalContent: this.modalContent(`Loading`, 'Please wait', true)
          });
        } else {
          const { percent, motivation } = this.state;
          this.setState({
            step: step + 1,
            percent: (percent / step) * (step + 1),
            motivation: motivation + 1
          });

          props.validateForm();
          props.setTouched({});
        }
      }
      else if (!props.isValid && this.state.step === 5) {
        this.pushToCMS(props.values);

        const { step, percent, motivation } = this.state;
        this.setState({
          step: step + 1,
          percent: (percent / step) * (step + 1),
          motivation: motivation + 1
        });
      }
    });
  };

  manualStep = (
    step: number | string,
    backStep: (null | number | string) = null,
    percent: (null | number) = null,
    motivation: (null | string) = null,
    props?: any,
    validate?: boolean,
    uploadedDocs: (boolean) = false
  ) => {
    if (validate || props) {
      props.submitForm().then(() => {
        if (props.isValid) {
          this.pushToCMS(props.values);

          this.setState({
            step: step,
            backStep: backStep,
            percent: percent,
            motivation: motivation,
            uploadedDocs: uploadedDocs,

            modalOpen: step === 'FINALLY' ? true : false,
            modalContent: step === 'FINALLY' ? this.modalContent('Thank you, we will be intouch soon...', '', true) : null
          });

          props.validateForm();
          props.setTouched({});
        }
      });
    } else {
      this.setState({
        step: step,
        backStep: backStep,
        percent: percent,
        motivation: motivation
      });
    }
  };

  modalContent = (title: string, msg?: string, spinner?: boolean) => {
    return (
      <React.Fragment>
        <Modal.Header style={{ textAlign: 'center' }}>{title}</Modal.Header>
        <Modal.Content style={{ textAlign: 'center' }}>
          {spinner ? <Icon loading name='spinner' size='massive' /> : null}
          <br />
          {msg ? <p>{msg}</p> : null}
        </Modal.Content>
      </React.Fragment>
    );
  };

  getValidationSchema = () => {
    if (this.state.step === 'EMAIL_FORM') {
      return this.EmailFormSchema
    } else {
      return this.schemaArray[this.state.step - 1]
    }
  }

  checkMarketingStr = (param: string): string | void => {
    const val = queryString(param);

    if (val) {
      return val + ': ' + moment().format('DD/MM/YYYY');
    }
  };

  // function will create object of K:V pairs of marketing info
  getMarketingData = () => {
    const queries = [
      'utm_term',
      'utm_source',
      'utm_medium',
      'utm_content',
      'utm_campaign'
    ];

    let marketingData = queries.reduce((queryObj: any, qString) => {
      let data = this.checkMarketingStr(qString);
      if (data) queryObj[qString.slice(4)] = data;
      return queryObj
    }, {});

    return marketingData;
  };

  pushToCMS = (formValues: any) => {
    const { sessionMarketingDataSent, step, leadId, revisitingLead, highCourtLead, timeRunningOut } = this.state;

    //check if marketing data has already been sent this session, if not, get it
    let marketingData = sessionMarketingDataSent ? null : this.getMarketingData();

    switch (step) {
      case 4:
        /* Completed Initial Registration */
        postLead(adapter(formValues, step, marketingData, revisitingLead, highCourtLead, timeRunningOut))()
          .then(response => {
            const values = {
              ref: response.data.ref,
              today: moment().format('DD/MM/YYYY'),
              firstName: formValues.stp3_firstName,
              lastName: formValues.stp3_lastName,
              houseNumName: formValues.stp2_houseNumName,
              streetRoad: formValues.stp2_streetRoad,
              town: formValues.stp2_town,
              postCode: formValues.stp2_postCode
            };

            getDBAPDF()
              .then((buffer) => buildPDF(buffer, values))
              .then((pdfUrl) => {
                this.setState({
                  leadId: response.data.id,
                  sessionMarketingDataSent: true,
                  modalOpen: false,
                  pdfUrl
                });
              });
          })
          .catch(error => {
            this.manualStep(0);
            console.log(error);
          });
        break;
      case 5:
        /* Agreed to DBA */
        putLead(leadId, adapter(formValues, step, marketingData, revisitingLead))()
          .then(() => {
            this.setState({
              sessionMarketingDataSent: true
            });
          })
          .catch(error => {
            this.manualStep(0);
            console.log(error);
          });
        break;
      default:
        //TODO: DO SOMETHING
        break;
    }
  };

  Step1Schema = Yup.object().shape({
    stp1_stillWorkThere: Yup.mixed().required(messages.stp1.currentlyWorking),
    stp1_endDate: Yup.string().when('stp1_stillWorkThere', {
      is: val => val === 'no',
      then: Yup.string()
        .required(messages.stp1.endDate)
        .test('step two - missing end date', messages.stp1.endDate, function(
          val
        ) {
          return moment(val, 'DD/MM/YYYY', true).isValid();
        })
        .test(
          'step two - end date cannot be in the future',
          messages.stp1.endDateFuture,
          function(val) {
            let endDate = moment(val, 'DD/MM/YYYY');
            let today = moment();
            return endDate.isBefore(today, 'day');
          }
        )
        .test(
          'step two - end date cannot be over 6 years',
          messages.stp1.moreThanSixYears,
          function(val) {
            let endDate = moment(val, 'DD/MM/YYYY');
            let sixYrs = moment().subtract(6, 'years');
            return endDate.isAfter(sixYrs, 'day');
          }
        )
    }),
    stp1_storeDetails: Yup.string()
      .required(messages.stp1.storeDetails)
      .min(1, messages.stp1.storeDetails)
      .max(50, messages.stp1.storeDetails),
    stp1_hourlyWage: Yup.string()
      .required(messages.stp1.hourlyWage)
      .test(
        'step one - hourly wage is no',
        messages.stp1.hourlyWageFalse,
        function(val) {
          return val !== 'no'
        })
  });

  Step2Schema = Yup.object().shape({
    stp2_postCode: Yup.string()
      .required(messages.stp2.postcode)
      .test('step three - valid postcode', messages.stp2.postcodeValid, function(
        postCode
      ) {
        return regexs.postCodeValid.test(postCode);
      }),
    stp2_houseNumName: Yup.string()
      .required(messages.stp2.houseNumName)
      .min(1, messages.stp2.houseNumName)
      .max(50, messages.stp2.houseNumName),
    stp2_streetRoad: Yup.string()
      .required(messages.stp2.streetRoad)
      .min(5, messages.stp2.streetRoad)
      .max(50, messages.stp2.streetRoad),
    stp2_town: Yup.string()
      .required(messages.stp2.townCity)
      .min(3, messages.stp2.townCity)
      .max(50, messages.stp2.townCity),
    stp2_country: Yup.string()
      .required(messages.stp2.country)
      .test('step two - valid country', messages.stp2.countryValid, function(
        country
      ) {
        return country === "England" || country === "Scotland" || country === "Wales" ? true : false;
      })
  });

  Step3Schema = Yup.object().shape({
    stp3_firstName: Yup.string()
      .required(messages.stp3.firstName)
      .test('step four - letters only', messages.util.lettersOnly, function(
        name
      ) {
        return regexs.lettersSpacesHyphen.test(name);
      })
      .min(2, messages.stp3.firstName)
      .max(50, messages.stp3.firstName),
    stp3_lastName: Yup.string()
      .required(messages.stp3.lastName)
      .test('step four - letters only', messages.util.lettersOnly, function(
        name
      ) {
        return regexs.lettersSpacesHyphen.test(name);
      })
      .min(2, messages.stp3.lastName)
      .max(50, messages.stp3.lastName),
    stp3_emailAddress: Yup.string()
      .required(messages.stp3.emailAddress)
      .email(messages.stp3.emailAddressValid),
    stp3_telephone: Yup.string()
      .required(messages.stp3.contactNo)
      .test(
        'step four - contact no valid',
        messages.stp3.contactNoValid,
        function(contactNo) {
          return regexs.contactNoValid.test(contactNo);
        }
      ),

    stp3_dob: Yup.string()
      .required(messages.stp3.dob)
      .test('step four - missing dob', messages.stp3.dob, function(val) {
        return moment(val, 'DD/MM/YYYY', true).isValid();
      })
      .test(
        'step four - must be older than 18',
        messages.stp3.dobValid,
        function(val) {
          let dob = moment(val, 'DD/MM/YYYY');
          let eighteenYrs = moment().subtract(18, 'years');
          return dob.isBefore(eighteenYrs, 'day');
        }
      ),
    stp3_gender: Yup.string().required(messages.stp3.gender),

    stp3_nationalInsurance: Yup.string()
      .test('step four - valid NI', messages.stp3.nationalInsurance, function(
        niNum
      ) {
        return niNum ? regexs.nationalInsuranceValid.test(niNum) : true;
      })
  });

  Step4Schema = Yup.object().shape({
    stp4_consentPermission: Yup.bool().oneOf(
      [true],
      'You must agree to this to continue.'
    ),
    stp4_contactPermission: Yup.bool().oneOf(
      [true],
      'You must agree to this to continue.'
    )
  });

  EmailFormSchema = Yup.object().shape({
    email_input: Yup.string()
      .required(messages.email_form.emailAddress)
      .email(messages.email_form.emailAddressValid)
  });

  schemaArray = [
    this.Step1Schema,
    this.Step2Schema,
    this.Step3Schema,
    this.Step4Schema
  ];

  handleSubmit = (values: any, formikbag: any) => {
    // do stuff
    setTimeout(() => {
      formikbag.setSubmitting(false);
    }, 1000);
  };

  formStep = (props: any) => {
    const { step } = this.state;
    switch (step) {
      case 0:
        setTimeout(() => {
          window.location.replace(process.env.REACT_APP_ERROR_URL || '');
        },
          3000);
        break;
      case 1:
        return (
          <WorkFormB
            {...props}
            nextStep={this.nextStep}
            gaEvent={this.gaEvent}
          />
        );
      case 2:
        return (
          <AddressForm
            {...props}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            gaEvent={this.gaEvent}
          />
        );
      case 3:
        return (
          <PersonalDetailsForm
            {...props}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            gaEvent={this.gaEvent}
          />
        );
      case 4:
        return (
          <ConsentForm
            {...props}
            nextStep={this.nextStep}
            prevStep={this.prevStep}
            gaEvent={this.gaEvent}
          />
        );
      case 5:
        return (
          <DBAFormTwo
            {...props}
            nextStep={this.nextStep}
            gaEvent={this.gaEvent}
            pdfUrl={this.state.pdfUrl}
          />
        );
      case 6:
        setTimeout(() => {
          window.location.replace(process.env.REACT_APP_CONFIRMATION_URL || '');
        },
          3000);
        break;
      case 'EMAIL_FORM':
        return (
          <EmailForm
            {...props}
            manualStep={this.manualStep}
            routeLead={this.routeRevisitingLead}
          />
        );
      case 'TIME_RUNNING_OUT':
        setTimeout(() => {
          window.location.replace(process.env.REACT_APP_COMPL_INIT_REG_TRO_URL || '');
        },
          3000);
        break;
      case 'HIGH_COURT_LEAD':
        setTimeout(() => {
          window.location.replace(process.env.REACT_APP_HIGH_COURT_URL || '');
        },
          3000);
        break;
      case 'FINALLY':
        setTimeout(() => {
          window.location.replace(process.env.REACT_APP_CONFIRMATION_URL || '');
        },
          3000);
        break;
    }
  };

  onKeyDown = (keyEvent: any) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  }

  render() {
    return (
      <React.Fragment>
        <PJModal
          size={this.state.modalSize}
          open={this.state.modalOpen}
          content={this.state.modalContent}
        />
        <Grid
          centered={true}
          textAlign="center"
          verticalAlign="top"
        >
          <Grid.Column style={{ margin: '0 15px' }}>
            <Formik
              onSubmit={this.handleSubmit}
              enableReinitialize={true}
              initialValues={{ ...this.state.formData }}
              validationSchema={this.getValidationSchema()}
              render={props => (
                <div style={{ border: '3px solid #8298af', borderRadius: '10px', padding: '10px', marginBottom: '10px' }}>
                  <Form className="ui large form" onKeyDown={this.onKeyDown}>
                    <Segment stacked>{this.formStep(props)}</Segment>
                    {/* <DisplayFormikState {...props} /> */}
                    <span className="payjustice-formstep" style={{ display: 'none' }} data-payjustice-formstep={this.state.step}>{this.state.step}</span>
                  </Form>
                </div>
              )}
            />

            {this.state.percent &&
              this.state.step !== 'EMAIL_FORM' &&
              this.state.step !== 6 &&
              this.state.step !== 7 &&
              this.state.step !== 8 &&
              this.state.step !== 9 ?
              <div>
                <Progress percent={this.state.percent} indicating />
              </div> : null
            }

          </Grid.Column>
        </Grid>
      </React.Fragment>
    );
  }
}

export default App;
